import { useRef } from 'react';
import { TooltipInitialState, useTooltipState } from 'reakit/Tooltip';

export function useDelayedTooltipState(initialState: TooltipInitialState, delay = 0) {
    const tooltip = useTooltipState(initialState);
    const showTimeout = useRef<ReturnType<typeof setTimeout>>();

    if (!delay) {
        return tooltip;
    }

    return {
        ...tooltip,
        show: () => {
            showTimeout.current = setTimeout(() => {
                tooltip.show();
            }, delay);
        },
        hide: () => {
            if (showTimeout.current) {
                clearTimeout(showTimeout.current);
            }

            tooltip.hide();
        },
    };
}
